import { useState } from 'react'
import React from 'react'

import { Box, Button, Icon } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { categoryTemplateListExtended } from 'modules/finance/lib/newSpendingPoliciesWizard'

type Props = {
  closeModal: () => void
  setIcon: (icon: string) => void
  defaultIcon: string
}

const IconListModal = ({ closeModal, setIcon, defaultIcon }: Props) => {
  const icons = categoryTemplateListExtended()

  const [selectedIcon, setSelectedIcon] = useState(defaultIcon)

  const handleSubmit = () => {
    setIcon(selectedIcon)
    closeModal()
  }

  return (
    <Modal
      illustration="pencil"
      title={i18n.t('spending_policies.details.form.icon_selector_modal.title')}
      description={i18n.t('spending_policies.details.form.icon_selector_modal.description')}
      footer={
        <>
          <Button type="secondary" onClick={closeModal}>
            {i18n.t('common.cancel')}
          </Button>
          <Button submit>{i18n.t(`common.save`)}</Button>
        </>
      }
      onSubmit={handleSubmit}
      onClose={closeModal}
    >
      <Box
        flexDirection="row"
        justifyContent="spaceBetween"
        alignItems="center"
        maxWidth="s400"
        flexWrap="wrap"
        gap="s16"
      >
        {icons.map((icon) => (
          <Box
            key={icon.icon}
            onClick={() => setSelectedIcon(icon.icon)}
            width="s64"
            height="s64"
            padding="s8"
            gap="s8"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            cursor="pointer"
            background={icon.color}
            borderRadius={{ all: 'abs008' }}
            border={
              icon.icon === selectedIcon
                ? { all: { width: 's2', style: 'solid', color: 'grey800' } }
                : undefined
            }
          >
            <Icon.Medium icon={icon.icon} color={icon.badgeColor} />
          </Box>
        ))}
      </Box>
    </Modal>
  )
}

export default React.memo(IconListModal)
